// i18next bootstrap. Imported once for side effects from src/frontend.tsx
// (the bun shadcn template's client entry); subsequent imports reuse the
// same singleton. Components consume via `useTranslation()` from
// `react-i18next`.
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ru from "./locales/ru.json";

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ru: { translation: ru },
		},
		fallbackLng: "en",
		supportedLngs: ["en", "ru"],
		interpolation: { escapeValue: false },
	});

export default i18n;
